import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import UseApi from "./pages/code-playground";
import SkillsLaboratory from "./pages/skills-laboratory";
import AboutUniverse from "./pages/about-universe";
import HeroLaunchPad from "./pages/hero-launch-pad";
import ExperienceTimeline from "./pages/experience-timeline";
import ContactUs from "./pages/contact-us";
import ProjectShowcaseGallery from "./pages/project-showcase-gallery";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your route here */}
          <Route path="/" element={<AboutUniverse />} />
          {/* <Route path="/code-playground" element={<UseApi />} /> */}
          <Route path="/skills-laboratory" element={<SkillsLaboratory />} />
          <Route path="/about-universe" element={<AboutUniverse />} />
          <Route path="/hero-launch-pad" element={<HeroLaunchPad />} />
          <Route path="/experience-timeline" element={<ExperienceTimeline />} />
          <Route path="/contact" element={<ContactUs />} />
          {/* <Route
            path="/project-showcase-gallery"
            element={<ProjectShowcaseGallery />}
          /> */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
